var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-panel", attrs: { id: "deliverable-detail" } },
    [
      _c("header", { staticClass: "task-panel-header" }, [
        _vm.navigationStack.length
          ? _c(
              "button",
              {
                staticClass: "icon-action back-action",
                attrs: {
                  type: "button",
                  "aria-label":
                    _vm.navigationStack[_vm.navigationStack.length - 1]
                      .deliverable.name,
                  title:
                    _vm.navigationStack[_vm.navigationStack.length - 1]
                      .deliverable.name,
                  disabled: _vm.isSaving || _vm.isNavigating
                },
                on: { click: _vm.navigateBack }
              },
              [_c("portal-icon", { attrs: { name: "arrow-left", size: 18 } })],
              1
            )
          : _vm._e(),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.deliverable.name,
              expression: "deliverable.name"
            }
          ],
          staticClass: "task-title-input",
          attrs: {
            type: "text",
            disabled: _vm.isReadOnly,
            "aria-label": _vm.$t("projects.deliverable-name"),
            placeholder: _vm.$t("projects.new-deliverable")
          },
          domProps: { value: _vm.deliverable.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.deliverable, "name", $event.target.value)
            }
          }
        }),
        _c("div", { staticClass: "task-panel-actions" }, [
          !_vm.isReadOnly
            ? _c(
                "button",
                {
                  staticClass: "save-action",
                  attrs: { type: "button", disabled: _vm.isSaving },
                  on: { click: _vm.saveAndCloseInternal }
                },
                [
                  _vm.isSaving
                    ? _c("v-progress-circular", {
                        attrs: { indeterminate: "", size: 14, width: 2 }
                      })
                    : _c("portal-icon", { attrs: { name: "check", size: 15 } }),
                  _vm._v(" " + _vm._s(_vm.$t("global.save")) + " ")
                ],
                1
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "icon-action",
              attrs: {
                type: "button",
                "aria-label": _vm.$t("global.close"),
                title: _vm.$t("global.close")
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.handleClose.apply(null, arguments)
                }
              }
            },
            [_c("portal-icon", { attrs: { name: "x", size: 19 } })],
            1
          )
        ])
      ]),
      _c("div", { staticClass: "task-panel-fixed" }, [
        _vm.isProjectSuspended(_vm.project)
          ? _c("p", { staticClass: "font-14", attrs: { role: "status" } }, [
              _vm._v(_vm._s(_vm.$t("projects.lifecycle-read-only")))
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "project-context" },
          [
            _c("portal-icon", { attrs: { name: "folder-kanban", size: 15 } }),
            _c("span", [_vm._v(_vm._s(_vm.project.name))]),
            _vm.navigationStack.length
              ? [
                  _c("portal-icon", {
                    attrs: { name: "chevron-right", size: 12 }
                  }),
                  _c("span", { staticClass: "parent-context" }, [
                    _vm._v(
                      _vm._s(
                        _vm.navigationStack[_vm.navigationStack.length - 1]
                          .deliverable.name
                      )
                    )
                  ])
                ]
              : _vm._e()
          ],
          2
        ),
        _c(
          "div",
          {
            staticClass: "task-tabs",
            style: {
              gridTemplateColumns:
                "repeat(" + _vm.visibleTabCount + ", minmax(0, 1fr))"
            },
            attrs: { role: "tablist" }
          },
          [
            _c(
              "button",
              {
                class: { active: _vm.tabItem === "overview" },
                attrs: {
                  type: "button",
                  role: "tab",
                  "aria-selected": _vm.tabItem === "overview"
                },
                on: {
                  click: function($event) {
                    _vm.tabItem = "overview"
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("projects.overview.heading")) + " ")]
            ),
            _vm.panelSubtasks.length
              ? _c(
                  "button",
                  {
                    class: { active: _vm.tabItem === "subtasks" },
                    attrs: {
                      type: "button",
                      role: "tab",
                      "aria-selected": _vm.tabItem === "subtasks"
                    },
                    on: {
                      click: function($event) {
                        _vm.tabItem = "subtasks"
                      }
                    }
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.$t("projects.subtasks")) + " "),
                    _c("span", { staticClass: "tab-count" }, [
                      _vm._v(_vm._s(_vm.panelSubtasks.length))
                    ])
                  ]
                )
              : _vm._e(),
            _c(
              "button",
              {
                class: { active: _vm.tabItem === "comments" },
                attrs: {
                  type: "button",
                  role: "tab",
                  "aria-selected": _vm.tabItem === "comments"
                },
                on: {
                  click: function($event) {
                    _vm.tabItem = "comments"
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("projects.feed")) + " ")]
            ),
            _c(
              "button",
              {
                class: { active: _vm.tabItem === "files" },
                attrs: {
                  type: "button",
                  role: "tab",
                  "aria-selected": _vm.tabItem === "files"
                },
                on: {
                  click: function($event) {
                    _vm.tabItem = "files"
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("nav.files")) + " ")]
            )
          ]
        )
      ]),
      _c("main", { staticClass: "task-panel-body show-scrollbar" }, [
        _c(
          "section",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tabItem === "overview",
                expression: "tabItem === 'overview'"
              }
            ],
            staticClass: "task-section"
          },
          [
            _c(
              "div",
              { staticClass: "meta-grid" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("projects.filter.status")))]),
                _c("v-select", {
                  staticClass: "panel-field",
                  attrs: {
                    "hide-details": "",
                    dense: "",
                    solo: "",
                    flat: "",
                    disabled: _vm.isReadOnly,
                    items: _vm.statusList,
                    "item-text": "label",
                    "item-value": "id",
                    "menu-props": {
                      contentClass: "task-status-menu",
                      offsetY: true
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "selection",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "status-chip",
                              style: { "--status-color": item.hexColor }
                            },
                            [_c("span"), _vm._v(_vm._s(item.label) + " ")]
                          )
                        ]
                      }
                    },
                    {
                      key: "item",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "status-chip",
                              style: { "--status-color": item.hexColor }
                            },
                            [_c("span"), _vm._v(_vm._s(item.label) + " ")]
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.deliverable.statusId,
                    callback: function($$v) {
                      _vm.$set(_vm.deliverable, "statusId", $$v)
                    },
                    expression: "deliverable.statusId"
                  }
                }),
                _c("label", [_vm._v(_vm._s(_vm.$t("projects.assigned-to")))]),
                _c(
                  "v-menu",
                  {
                    attrs: {
                      "close-on-click": true,
                      "close-on-content-click": false,
                      "offset-y": "",
                      disabled: _vm.isReadOnly
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "button",
                              _vm._g(
                                {
                                  staticClass: "assignee-field",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.isReadOnly
                                  }
                                },
                                on
                              ),
                              [
                                _vm.deliverable.assignedToList.length
                                  ? _c(
                                      "span",
                                      { staticClass: "assignee-stack" },
                                      _vm._l(
                                        _vm.deliverable.assignedToList,
                                        function(assignedTo, index) {
                                          return _c("assigned-user", {
                                            key: assignedTo,
                                            style: {
                                              zIndex:
                                                _vm.deliverable.assignedToList
                                                  .length - index
                                            },
                                            attrs: {
                                              "assigned-to": assignedTo,
                                              "show-name": false,
                                              "assignable-users":
                                                _vm.assignableUsers,
                                              "empty-label": "--"
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : _c("span", { staticClass: "empty-value" }, [
                                      _vm._v("—")
                                    ]),
                                _c("portal-icon", {
                                  attrs: { name: "chevron-down", size: 15 }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "assignee-menu" },
                      _vm._l(_vm.assignableUsers, function(user) {
                        return _c(
                          "label",
                          { key: user.userId, staticClass: "assignee-option" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.deliverable.assignedToList,
                                  expression: "deliverable.assignedToList"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: user.userId,
                                checked: Array.isArray(
                                  _vm.deliverable.assignedToList
                                )
                                  ? _vm._i(
                                      _vm.deliverable.assignedToList,
                                      user.userId
                                    ) > -1
                                  : _vm.deliverable.assignedToList
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.deliverable.assignedToList,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = user.userId,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.deliverable,
                                          "assignedToList",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.deliverable,
                                          "assignedToList",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.deliverable,
                                      "assignedToList",
                                      $$c
                                    )
                                  }
                                }
                              }
                            }),
                            user.userId
                              ? _c("assigned-user", {
                                  attrs: {
                                    "assigned-to": user.userId,
                                    "show-name": true,
                                    "assignable-users": _vm.assignableUsers
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]
                ),
                _c("label", [_vm._v(_vm._s(_vm.$t("projects.start")))]),
                _c("date-selector", {
                  attrs: {
                    date: _vm.deliverable.startDate,
                    label: null,
                    panel: true,
                    disabled: _vm.isReadOnly
                  },
                  on: {
                    change: function($event) {
                      _vm.deliverable.startDate = $event
                    }
                  }
                }),
                _c("label", [_vm._v(_vm._s(_vm.$t("projects.due")))]),
                _c("date-selector", {
                  attrs: {
                    date: _vm.deliverable.dueDate,
                    label: null,
                    panel: true,
                    disabled: _vm.isReadOnly
                  },
                  on: {
                    change: function($event) {
                      _vm.deliverable.dueDate = $event
                    }
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "panel-section" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("projects.description")))]),
              _c(
                "div",
                { staticClass: "description-editor" },
                [
                  _c("markdown", {
                    attrs: {
                      value: _vm.deliverable.description,
                      id: _vm.deliverable.id,
                      placeholder: _vm.$t("projects.description-placeholder"),
                      "input-only-mode": false,
                      solo: true,
                      flat: true,
                      disabled: _vm.isReadOnly
                    },
                    on: {
                      update: function($event) {
                        _vm.deliverable.description = $event
                      }
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "panel-section" }, [
              _c("h2", [
                _vm._v(" " + _vm._s(_vm.$t("projects.tasks")) + " "),
                _vm.deliverable.tasks && _vm.deliverable.tasks.length
                  ? _c("span", { staticClass: "section-count" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.completedTaskCount) +
                          "/" +
                          _vm._s(_vm.deliverable.tasks.length) +
                          " "
                      )
                    ])
                  : _vm._e()
              ]),
              _c(
                "div",
                { staticClass: "checklist-shell" },
                [
                  _c("tasks", {
                    ref: "tasks",
                    attrs: {
                      deliverable: _vm.deliverable,
                      "detail-view": true,
                      disabled: _vm.isReadOnly
                    }
                  })
                ],
                1
              )
            ]),
            _vm.deliverable.approvalRequired
              ? _c("div", { staticClass: "approval-card" }, [
                  _c("div", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("projects.client-workflow")))
                    ]),
                    _vm.deliverable.approvalRequestedAt
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("projects.submitted")) +
                              " " +
                              _vm._s(
                                _vm.DateTime.fromISO(
                                  _vm.deliverable.approvalRequestedAt
                                ).toFormat("DD")
                              ) +
                              " "
                          )
                        ])
                      : _vm._e()
                  ]),
                  !_vm.isProjectSuspended(_vm.project)
                    ? _c(
                        "button",
                        {
                          staticClass: "approval-action",
                          attrs: { type: "button" },
                          on: { click: _vm.confirmApproval }
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.$t("global.ok")) + " "),
                          _c("portal-icon", {
                            attrs: { name: "check", size: 15 }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.approvals.length
              ? _c("div", { staticClass: "panel-section" }, [
                  _c("h2", [
                    _vm._v(_vm._s(_vm.$t("projects.client-workflow")))
                  ]),
                  _c(
                    "ul",
                    { staticClass: "approval-history" },
                    _vm._l(_vm.approvals, function(approval) {
                      return _c("li", { key: approval.id }, [
                        _vm._v(
                          " " +
                            _vm._s(approval.approverName) +
                            " " +
                            _vm._s(_vm.$t("global.on")) +
                            " " +
                            _vm._s(
                              _vm.DateTime.fromISO(
                                approval.approvedAt
                              ).toFormat("DD")
                            ) +
                            " " +
                            _vm._s(_vm.$t("global.from")) +
                            " [" +
                            _vm._s(approval.approvalStatus) +
                            "] " +
                            _vm._s(_vm.$t("global.status")) +
                            " "
                        )
                      ])
                    }),
                    0
                  )
                ])
              : _vm._e()
          ]
        ),
        _vm.panelSubtasks.length
          ? _c(
              "section",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabItem === "subtasks",
                    expression: "tabItem === 'subtasks'"
                  }
                ],
                staticClass: "task-section"
              },
              [
                _c(
                  "div",
                  { staticClass: "subtask-list" },
                  _vm._l(_vm.panelSubtasks, function(subtask) {
                    return _c(
                      "button",
                      {
                        key: subtask.id,
                        staticClass: "subtask-row",
                        attrs: { type: "button", disabled: _vm.isNavigating },
                        on: {
                          click: function($event) {
                            return _vm.openSubtask(subtask)
                          }
                        }
                      },
                      [
                        _c("span", {
                          staticClass: "subtask-status-dot",
                          style: {
                            backgroundColor:
                              _vm.statusForSubtask(subtask).hexColor ||
                              "var(--portal-muted)"
                          }
                        }),
                        _c("div", { staticClass: "subtask-copy" }, [
                          _c("strong", [_vm._v(_vm._s(subtask.name))]),
                          _c("div", { staticClass: "subtask-meta" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.statusForSubtask(subtask).label ||
                                    _vm.$t("projects.no-status")
                                )
                              )
                            ]),
                            subtask.dueDate
                              ? _c(
                                  "span",
                                  { staticClass: "subtask-due" },
                                  [
                                    _c("portal-icon", {
                                      attrs: { name: "calendar-days", size: 13 }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.DateTime.fromISO(
                                            subtask.dueDate
                                          ).toLocaleString(
                                            _vm.DateTime.DATE_MED
                                          )
                                        ) +
                                        " "
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ]),
                        _c("portal-icon", {
                          staticClass: "subtask-open-icon",
                          attrs: { name: "chevron-right", size: 17 }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              ]
            )
          : _vm._e(),
        _c(
          "section",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tabItem === "comments",
                expression: "tabItem === 'comments'"
              }
            ],
            staticClass: "task-section comments-section"
          },
          [
            _c("activity", {
              ref: "activity",
              attrs: {
                project: _vm.project,
                deliverable: _vm.deliverable,
                "project-service": _vm.projectService
              }
            })
          ],
          1
        ),
        _vm.tabItem === "files"
          ? _c(
              "section",
              {
                staticClass: "task-section files-section",
                attrs: { id: "deliverable-files" }
              },
              [
                _c("domain-root", {
                  attrs: {
                    type: "Task",
                    id: _vm.deliverable.id,
                    "show-deleted": _vm.showDeleted,
                    "read-only": _vm.isReadOnly,
                    "allow-upload": _vm.canUploadFiles
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      !_vm.isReadOnly
        ? _c("footer", { staticClass: "task-panel-footer" }, [
            _c(
              "button",
              {
                staticClass: "delete-action",
                attrs: { type: "button" },
                on: { click: _vm.confirmDeleteDeliverable }
              },
              [
                _c("portal-icon", { attrs: { name: "trash-2", size: 15 } }),
                _vm._v(" " + _vm._s(_vm.$t("global.delete")) + " ")
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }